import { publicHref } from '../lib/publicUrls';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { TourClosing } from '../components/TourJourney';
import MediaTruthSurface from '../components/MediaTruthSurface';
import { MEDIA_SLOTS } from '../lib/mediaTruth';
import './ClubPages.css';

const highlights = [
  '55,000+ square foot Brentwood facility',
  '12+ dedicated rooms for exercise and wellness',
  'Full-sized basketball courts',
  'Heated indoor Olympic-sized lap pool',
  'Heated indoor swim lesson pool',
  'Reformer Pilates studio',
  'Steam rooms and saunas',
];

const AboutPage = () => (
  <main className="dv-club-pages" data-testid="about-page">
    <SEO
      title="About Delta Valley Health Club"
      description="Learn the story of Delta Valley Health Club, a family-owned hometown health club serving Brentwood and Discovery Bay since 2002."
      keywords="Delta Valley Health Club history, family owned gym Brentwood, gym Discovery Bay"
    />
    <section className="dv-club-pages__hero" aria-labelledby="club-story-title">
      <div className="dv-club-pages__hero-inner">
        <div>
          <p className="uppercase tracking-[0.25em] text-sm font-semibold mb-4">Since 2002</p>
          <h1 id="club-story-title" className="dv-size-heading text-4xl md:text-6xl font-bold mb-6">The Delta Valley Story</h1>
          <p className="dv-size-lede text-xl">A premier hometown health club built for the whole family.</p>
        </div>
      </div>
    </section>
    <nav className="dv-club-pages__navigation" aria-label="Club story and community">
      <Link to={publicHref("/about-us")} aria-current="page">Our Story</Link>
      <Link to={publicHref("/partnerships")}>Community Partnerships</Link>
    </nav>
    <section className="dv-club-pages__story" aria-label="Club history and ownership">
        <div className="dv-club-pages__story-copy space-y-6 text-lg leading-relaxed">
          <p className="dv-size-body">
            With deep roots in East Contra Costa County and a background in construction,
            owner Matt Ellison saw that the community needed more than a gym: it
            needed a premier health club where the entire family could belong.
          </p>
          <p className="dv-size-body">
            Matt built the health club in 2002 and contracted Club One to run operations. In 2010,
            the facility became Delta Valley Athletic Club, continuing the commitment to an
            exceptional community health club.
          </p>
          <p className="dv-size-body">
            We believe fitness is more than a membership. It is a lifestyle and a community where
            wellness encompasses mind, body, and spirit. Exercise, personal training, group
            classes, therapeutic massage, youth events, and community activities all help create
            a unique experience centered on health and fun.
          </p>
          <p className="dv-size-body">
            Whether your goal is to get back in shape, lose weight, follow your doctor&apos;s
            guidance, build strength, or simply feel better, our friendly and certified staff are
            here to personalize your experience.
          </p>
          <div className="pt-2">
            <p className="font-semibold ">Kristie and Matt Ellison, Owners</p>
            <a className="dv-club-pages__email hover:underline" href="mailto:info@deltavac.com">info@deltavac.com</a>
          </div>
        </div>
      <figure className="dv-club-pages__portrait">
        <MediaTruthSurface media={MEDIA_SLOTS.aboutHero} className="dv-club-pages__photo" />
        <figcaption>Delta Valley Health Club</figcaption>
      </figure>
    </section>
    <section className="dv-club-pages__highlights-section" aria-labelledby="club-highlights-title">
      <div className="dv-club-pages__section-heading">
        <p className="dv-eyebrow">Brentwood facility</p>
        <h2 id="club-highlights-title" className="dv-size-heading text-2xl font-bold">Club Highlights</h2>
      </div>
      <ul className="dv-club-pages__highlights">
        {highlights.map(highlight => <li key={highlight} className="dv-size-body"><span>{highlight}</span></li>)}
      </ul>
    </section>
    <section className="dv-club-pages__locations" aria-labelledby="club-locations-title">
      <h2 id="club-locations-title" className="dv-size-heading text-3xl md:text-4xl font-bold">Our clubs and community</h2>
      <div className="dv-club-pages__location-pair">
        <article className="dv-club-pages__location dv-club-pages__location--primary" aria-labelledby="brentwood-title">
          <p className="dv-eyebrow">Primary club</p>
          <h3 id="brentwood-title" className="dv-size-subheading font-bold text-lg mb-1">Brentwood Club</h3>
          <p className="dv-size-body text-sm">120 Guthrie Lane</p>
          <div className="dv-club-pages__aquatics">
            <h4 className="dv-size-subheading font-bold text-lg mb-1">Year-Round Aquatics</h4>
            <p className="dv-size-body text-sm">Indoor heated pools and lessons</p>
          </div>
        </article>
        <article className="dv-club-pages__location" aria-labelledby="discovery-bay-title">
          <h3 id="discovery-bay-title" className="dv-size-subheading font-bold text-lg mb-1">Discovery Bay Club</h3>
          <p className="dv-size-body text-sm">1520 Discovery Bay Boulevard</p>
        </article>
      </div>
      <div className="dv-club-pages__community-notes">
        <div><h3 className="dv-size-subheading font-bold text-lg mb-1">For Every Age</h3><p className="dv-size-body text-sm">Programs for children through adults</p></div>
        <div><h3 className="dv-size-subheading font-bold text-lg mb-1">Community First</h3><p className="dv-size-body text-sm">Family owned and locally connected</p></div>
      </div>
    </section>
    <TourClosing />
  </main>
);

export default AboutPage;
